import script from "./BulkCartesianForm.vue?vue&type=script&setup=true&lang=js"
export * from "./BulkCartesianForm.vue?vue&type=script&setup=true&lang=js"

import "./BulkCartesianForm.vue?vue&type=style&index=0&id=66fa19d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66fa19d6"]])

export default __exports__